import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Grid, Stack, Typography, useTheme } from '@mui/material';
import { StyledPaperItem } from '../common/mui-components';

type PropTypes = {
  close: () => void;
  open: boolean;
};

export const SearchPoolAbout = ({ close, open }: PropTypes) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={close} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h5" textAlign={'center'}>
          The new SEARCH feature
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Box
          sx={{
            position: 'relative',
            flexGrow: 1,
          }}
        >
          <Grid container spacing={2} className="CONTAINER-MAIN">
            <Grid item xs={12} sm={12} className="CONTAINER-TOP">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3} className="SEARCH-PIC">
                  <StyledPaperItem
                    sx={{
                      paddingX: 2,
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1687821509/SearchMenu_het1rq.png'
                      }
                      alt="image"
                      sx={{ maxWidth: '100%' }}
                    />
                  </StyledPaperItem>
                </Grid>
                <Grid item xs={12} sm={9} className="DESCRIPTION">
                  <StyledPaperItem
                    sx={{
                      paddingX: 2,
                    }}
                  >
                    <Stack
                      spacing={5}
                      mb={1}
                      sx={{ color: theme.palette.dailies.main }}
                    >
                      <Typography>
                        SEARCH is an asynchronous match-making feature for
                        head-to-head games.
                      </Typography>
                      <Typography>
                        When you play a Searched match, you will be matched
                        against an opponent with a similar MMR as you.
                      </Typography>
                      <Typography>
                        There are two parts to Search: seeding and searching.
                        Players will alternate from seeding games into the pool
                        and searching games from the pool. This will ensure that
                        the pool sustains a healthy volume of games.
                      </Typography>
                    </Stack>
                  </StyledPaperItem>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} className="MID">
              <Grid container spacing={2}>
                <Grid item xs={6} sm={9} className="PHASE-ONE">
                  <StyledPaperItem
                    sx={{
                      paddingX: 2,
                    }}
                  >
                    <Stack
                      spacing={5}
                      sx={{ color: theme.palette.success.main }}
                    >
                      <Typography>
                        Before enabling Search, an initial "seed round" is
                        needed to populate the pool. This feature will be very
                        community driven so we hope many of you will help with
                        the first batch of games.
                      </Typography>
                      <Typography>
                        You can seed games from the Play menu. Each player can
                        seed up to a maximum of 10 games.
                      </Typography>
                      <Typography>
                        You can follow the seeding progress on the Main page
                      </Typography>
                    </Stack>
                  </StyledPaperItem>
                </Grid>
                <Grid item xs={6} sm={3} className="SEED-PIC">
                  <StyledPaperItem
                    sx={{
                      paddingX: 2,
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1687820636/SeedMenu_cvbcf8.png'
                      }
                      alt="image"
                      sx={{ maxWidth: '100%' }}
                    />
                  </StyledPaperItem>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};
